import { useCallback } from 'react';
import {
  useNavigate,
  useLocation,
  useSearchParams as useSearchParamsNN,
} from 'react-router-dom';

export const useSearchParams = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const [searchParams] = useSearchParamsNN();

  const setSearchParams = useCallback(
    (newSearchParams: { [key: string]: string | number | undefined }) => {
      const params = new URLSearchParams(searchParams.toString());

      const newSearchParamsArray = Object.entries(newSearchParams);

      for (const p of newSearchParamsArray) {
        if (p[1]) {
          params.set(p[0], p[1].toString());
        } else {
          params.delete(p[0]);
        }
      }

      navigate(pathname + '?' + params.toString());

      return params.toString();
    },
    [searchParams, pathname, navigate]
  );

  return { searchParams, setSearchParams };
};
